import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { FlatTransport } from '@/models/FlatTransport'

export default new CachedResourceStore<FlatTransport>(FlatTransport, {
	namespaced: true
})
